import { chatAction } from '@/store'
import { ArrowRight } from 'lucide-react'

interface IProps {
  related: string[]
}

export default function Related({ related }: IProps) {
  return (
    <div className="flex gap-3 flex-col">
      {related.map((text: string, index: number) => (
        <div
          className="w-fit flex items-center gap-2 text-sm cursor-pointer px-4 py-3 border border-[#1C1F230F] rounded-xl hover:bg-[#1C1F230F]"
          key={index}
          onClick={() => {
            chatAction.onUserSubmit({
              text,
            })
          }}
        >
          <span>{text}</span>
          <ArrowRight size={16} />
        </div>
      ))}
    </div>
  )
}
